import React, { useEffect } from "react";
import { Header } from "../../../Components/Header/Header";
import { Grid } from "@mui/material";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import WSDateField from "../../../Components/DateField/WSDateField";
import WSHiddenField from "../../../Components/HiddenField/WSHiddenField";
import WSButton from "../../../Components/Button/WSButton";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
import WSPhone from "../../../Components/Phone/WSPhone";
import { callAPI, clearRequest, customValidation, Method, validations } from "../../../commonFunctions/CommonFunctions";
import WSSelectField from "../../../Components/Select/WSSelect";
import config from "../../../Config/clientConfig.json"
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import dayjs from "dayjs";
export const UserRegistration:React.FC<any>=React.memo((props)=>{
  const { control, register, handleSubmit, reset, setValue } = useForm();
  const { showMessage } = useSnackbar();
  const params = useParams();
  const navigate = useNavigate();

  const id = params?.id;

  useEffect(
    () => () => {
      reset();
    },
    []
  );
  useEffect(() => {
    /**
     * Edit Function
     * @param id
     *
     */
    async function getUserById(id: any) {
      try {
        const response: any = await callAPI("User", Method.GET, {}, id);

        if (response && response?.data) {
          setValue("name", response.data?.name);
          setValue("phoneno", response.data?.phoneno);
          setValue("email", response.data?.email);
          setValue("addressOne", response.data?.addressOne);
          setValue("addressTwo", response.data?.addressTwo);
          setValue("city", response.data?.city);
          setValue("state", response.data?.state);
          setValue("postalCode", response.data?.postalCode);
          setValue("dob", response.data?.dob);
          setValue("anniversary", response.data?.anniversary);

          setValue("id", response.data?.id);
        }
      } catch (error) {
        console.log("failed to retrieve data", error);
      }
    }
    if (id) {
      getUserById(id);
    }
  }, [id, setValue]);


    const handleCancelClick = () => {
        navigate("/userregistration/list");
      };

     /**
   * Method for Add/Update the data
   * @param data
   */
  const handleData = async (data: any) => {
    try {
console.log("submitted data",data);
const dateofBirth = dayjs(data.dateofBirth).format('YYYY-MM-DDTHH:mm:ss.SSS')
const anniverasaryDate = dayjs(data.anniverasaryDate).format('YYYY-MM-DDTHH:mm:ss.SSS')
      let request = {
        name: data.name,
        phoneno:data.phoneno,
        email:data.email,
        addressOne:data.addressOne,
        addressTwo:data.addressTwo,
        city:data.city,
        state:data.state,
        postalCode:data.postalCode,
        dob:dateofBirth,
        anniversary:anniverasaryDate,
        id: data.id,
      };
      const newRequest = clearRequest(request)

      if (id) {
        const response: any = await callAPI(`User/${id}`, Method.PUT, newRequest);
        if (response) {
          showMessage(
            response?.message,
            response.success === true ? "success" : "error"
          );
          response.success === true && navigate("/user/list");
        }
      } else {
        const response: any = await callAPI("User/create", Method.POST, newRequest);
        if (response) {
          showMessage(
            response?.message,
            response.success === true ? "success" : "error"
          );
          response.success === true && navigate("/user/list");
        }
      }
    } catch (e: any) {
      showMessage(e.error);
    }
  };
    return(
        <>
        <Header
        type="simple"
        isDivider={true}
        title={`${id ? "Edit" : "Add"} User Registration`}
        url="/user/list"
        id={"userregistrationImg"}
        isBackButton={true}
        headerSx={{ marginTop: 0 }}
      />
      <form onSubmit={handleSubmit(handleData)}>
        <Grid
          sx={{
            padding: 4,
            backgroundColor: "#fff",
            borderRadius: 2,
            border: "1px solid lightgrey",
            marginTop: 3,
          }}
        >

          <Grid container spacing={2}>
           
          <Grid item xs={12} sm={6}>
             <WSTextField
               label={"Full Name"}
               {...register("name")}
               id="name"
               name="name"
               control={control}
               rules={{ required: true }}
               labelType="Normal"
             />
           </Grid>
           <Grid item xs={12} sm={6}>
             <WSPhone
               label={"Phone Number"}
               id={"phoneno"}
               name={"phoneno"}
               control={control}
               labelType="Normal"
               rules={{ required: true }}
             />
           </Grid>
           <Grid item xs={12} >
            <WSTextField
                    control={control}
                    className="form-control"
                    id="email"
                    {...register("email")}
                    rules={customValidation(true, validations.email)}
                    name="email"
                    label="Email Address "
                    labelType="Normal"
                />
            </Grid>
            <Grid item xs={12}>
          <WSTextField
            control={control}
            id="addressOne"
            {...register("addressOne")}
            rules={{ required: true }}
            name="addressOne"
            label="Address line1 *"
            labelType="Normal"
          />
        </Grid>
        <Grid item xs={12}>
          <WSTextField
            control={control}
            id="addressTwo"
            {...register("addressTwo")}
            rules={{ required: false }}
            name="addressTwo"
            label="Address line2"
            labelType="Normal"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <WSTextField
            control={control}
            id="city"
            {...register("city")}
            rules={{ required: true }}
            name="city"
            label="City *"
            //labelType="Normal"
          />
        </Grid>
        <Grid item container xs={12} sm={4}>
          <WSSelectField
            options={config.stateConfig.staticOptionData}
            rules={{ required: true }}
            {...register("state")}
            id="state"
            control={control}
            defaultValue={"0"}
            label="State *"
            name="state" 
            // labelType="Normal"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <WSTextField
            control={control}
            id="postalCode"
            {...register("postalCode")}
            rules={{ required: true }}
            name="postalCode"
            label="Postal Code *"
            // labelType="Normal"
            maxLength={6}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
              <WSDateField
                id="dob"
                name="dob"
                label={"Date of Birth"}
                dateFormat="YYYY/MM/D"
                control={control}
                denyFuturOrPast="future"
                defaultValue={null}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSDateField
                id="anniversary"
                name="anniversary"
                label={"Anniversary"}
                dateFormat="YYYY/MM/D"
                control={control}
                defaultValue={null}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSHiddenField name="id" control={control} />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                marginTop: "3rem",
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
              }}
            >
              <WSButton
                id="submit"
                label={"Save"}
                onClick={handleSubmit(handleData)}
                type="submit"
                size="medium"
              />
              <WSButton
                id="cancel"
                label={"Cancel"}
                type="button"
                size="medium"
                className="ws-cancel"
                onClick={handleCancelClick}
              />
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
    )
})